<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: "info"
    },
    size: {
      type: String,
      required: false
    }
  }
};
</script>

<template>
  <p
    :class="{
      info: type === 'info',
      alert: type === 'alert',
      small: size === 'small',
    }"
  >
    <slot />
  </p>
</template>

<style scoped>
p {
  width: 100%;
  margin: 12px 0 8px;
  text-align: center;
  font-size: 14px;
  user-select: none;
}

p.info {
  color: #888;
  font-size: 14px;
  font-weight: 400;
}

p.alert {
  color: #af006b;
  font-weight: 400;
  margin: 8px 0 4px;
}

p.small {
  font-size: 12px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/_base/Tip.vue